<link
  href="https://fonts.googleapis.com/icon?family=Material+Icons"
  rel="stylesheet"
  crossorigin="anonymous"
/>
<link
  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined"
  rel="stylesheet"
  crossorigin="anonymous"
/>

<div class="duna-dashboard">
  @if (showDashboardChrome) {
  <div class="dashboard-header">
    <div class="actions-left">
      <ng-container *ngrxLet="isSuperadmin$ as isSuperadmin">
        @if (isSuperadmin) {
        <button
          mat-raised-button
          color="primary"
          routerLink="/template-generator"
        >
          TG
        </button>
        } @if (isSuperadmin) {
        <button mat-raised-button color="primary" routerLink="/cprng">
          CPRNG
        </button>
        }
      </ng-container>
      @if (isShareLinkAdminFiltersView) {
      <button
        mat-raised-button
        color="primary"
        (click)="saveShareLinkFilters()"
        [disabled]="savingShareLinkFilters"
      >
        Gem filtre på link
      </button>
      }
      <ng-container *ngrxLet="canEditDashboard$ as canEdit">
        @if (canEdit && viewMode === 'default') {
        <button mat-raised-button color="primary" (click)="toggleEditMode()">
          {{ editMode ? "Afslut Redigering" : "Rediger Dashboard" }}
        </button>
        } @if (editMode && canEdit && viewMode === 'default') {
        <button
          mat-raised-button
          color="accent"
          (click)="openAddWidgetDialog()"
        >
          + Tilføj widget
        </button>
        <button
          mat-icon-button
          color="primary"
          (click)="saveDashboard()"
          class="action-button"
          title="Gem dine personlige tilpasninger"
        >
          <mat-icon>save</mat-icon>
        </button>
        <button
          mat-icon-button
          color="warn"
          (click)="resetDashboard()"
          class="action-button"
          title="Nulstil til standard skabelon (sletter alle tilpasninger)"
        >
          <mat-icon>refresh</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          (click)="openTemplateManager()"
          class="action-button"
          title="Vælg og administrer skabeloner"
        >
          <mat-icon>dashboard</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          (click)="handleUndo()"
          [disabled]="pastLayouts.length <= 1"
          class="action-button"
          title="Fortryd"
        >
          <mat-icon>undo</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          (click)="handleRedo()"
          [disabled]="futureLayouts.length === 0"
          class="action-button"
          title="Annuller fortryd"
        >
          <mat-icon>redo</mat-icon>
        </button>
        }
      </ng-container>
    </div>

    @if (editMode && loadedDashboard) {
    <div class="actions-right">
      <div class="loaded-dashboard-info">
        <mat-icon>dashboard</mat-icon>
        <span>
          Redigerer: <strong>{{ loadedDashboard.name }}</strong>
          <span class="save-scope personal">— gemmes kun for dig</span>
        </span>
      </div>
    </div>
    }
  </div>
  }

  <!-- Improved dashboard container layout -->
  <div class="dashboard-outer-container" #dashboardOuter>
    @if (options) {
    <div class="dashboard-container">
      <!-- Show placeholder during rapid recreations to stabilize UI -->
      @if (initializing && DunaDashboardComponent.recreationCount >=
      DunaDashboardComponent.MAX_RECREATIONS) {
      <div class="stable-placeholder">
        <div class="loading-spinner"></div>
        <p>Indlæser dashboard...</p>
      </div>
      }
      <!-- Empty state when no templates are available -->
      @if (showEmptyState) {
      <div class="empty-state">
        <div class="empty-state-content">
          <mat-icon class="empty-state-icon">dashboard</mat-icon>
          <h2>Ingen dashboard skabeloner tilgængelige</h2>
          <p>
            Der er ingen dashboard skabeloner tilgængelige i systemet. Kontakt
            din administrator for at få oprettet en skabelon.
          </p>
          <button mat-raised-button color="primary" (click)="loadDashboard()">
            Prøv igen
          </button>
        </div>
      </div>
      }
      <!-- Only render Gridster when options and dashboard are ready -->
      @if (!showEmptyState) {
      <gridster [options]="options" class="dashboard-gridster">
        <!-- Loading indicator -->
        @if (isSaving) {
        <div class="dashboard-loading">
          <div class="loading-spinner"></div>
          <p>Gemmer dashboard...</p>
        </div>
        }
        <!-- No widgets message -->
        @if (dashboard && dashboard.length === 0 && !isSaving && !initializing)
        {
        <div class="no-widgets-message">
          <p>
            Ingen widgets på dashboard. Klik på "Tilføj widget" for at tilføje.
          </p>
        </div>
        } @for (widget of dashboard; track trackByTileId($index, widget)) {
        <gridster-item [item]="getGridsterItem(widget)" class="widget-item">
          <div
            class="dashboard-widget"
            [class.edit-mode]="editMode"
            [attr.data-widget-id]="widget.id"
            [attr.data-widget-type]="widget.type"
          >
            <!-- Widget header - always visible -->
            <div class="widget-header">
              <ng-container *ngrxLet="canEditDashboard$ as canEdit">
                @if (editMode && canEdit) {
                <div class="drag-handle">
                  <mat-icon aria-hidden="true">drag_indicator</mat-icon>
                  <h3 class="widget-title">{{ widget.title }}</h3>
                </div>
                } @if (!editMode || !canEdit) {
                <h3 class="widget-title">{{ widget.title }}</h3>
                }
                <div class="widget-actions">
                  @if (hasFilteringSupport(widget.type) && canOpenWidgetFilters()) { @if (widget.type ===
                  'userProgress' || widget.type === 'userProgressStats' ||
                  widget.type === 'locationProgress' || widget.type ===
                  'simpleNumber') {
                  <div class="filter-indicators">
                    <!-- Station/Location filter indicator for user progress -->
                    @if ((widget.type === 'userProgress' || widget.type ===
                    'userProgressStats' || widget.type === 'simpleNumber') &&
                    hasStationFilters(widget.settings?.filters)) {
                    <span
                      class="filter-indicator"
                      (click)="openFilterModal(widget)"
                    >
                      <mat-icon>location_on</mat-icon>
                    </span>
                    }
                    <!-- Status filter indicator for location progress -->
                    @if (widget.type === 'locationProgress' &&
                    (widget.settings?.filters['status'] ?? '') !== '' &&
                    (widget.settings?.filters['status'] ?? '') !== 'all') {
                    <span
                      class="filter-indicator"
                      (click)="openFilterModal(widget)"
                    >
                      <mat-icon>warning</mat-icon>
                    </span>
                    }
                    <!-- Educational path filter indicator for both types -->
                    @if ((widget.settings?.filters['educationalPathId'] ?? '')
                    !== '' && (widget.settings?.filters['educationalPathId']
                    ?? '') !== 'all') {
                    <span
                      class="filter-indicator"
                      (click)="openFilterModal(widget)"
                    >
                      <mat-icon>school</mat-icon>
                    </span>
                    }
                    <!-- User group filter indicator -->
                    @if ((widget.settings?.filters['groupId'] ?? '') !== '' &&
                    (widget.settings?.filters['groupId'] ?? '') !== 'all') {
                    <span
                      class="filter-indicator"
                      (click)="openFilterModal(widget)"
                    >
                      <mat-icon>groups</mat-icon>
                    </span>
                    }
                    <!-- Legacy group filter indicator -->
                    @if ((widget.settings?.filters['group'] ?? '') !== '' &&
                    (widget.settings?.filters['group'] ?? '') !== 'all') {
                    <span
                      class="filter-indicator"
                      (click)="openFilterModal(widget)"
                    >
                      <mat-icon>group</mat-icon>
                    </span>
                    }
                  </div>
                  }
                  <button
                    mat-icon-button
                    (click)="openFilterModal(widget)"
                    class="widget-action-button"
                    title="{{
                      widget.type === 'userProgress' ||
                      widget.type === 'userProgressStats'
                        ? 'Filter by name or location'
                        : widget.type === 'locationProgress'
                        ? 'Filter by status or uddannelsesvej'
                        : widget.type === 'simpleNumber'
                        ? 'Vælg metrik og filtre'
                        : widget.type === 'cateringSummary'
                        ? 'Vælg periode og forplejningsgruppe'
                        : widget.type === 'eventsCalendar'
                        ? 'Filtrer begivenheder'
                        : 'Filter content'
                    }}"
                  >
                    <mat-icon>{{
                      widget.type === "simpleNumber" ? "tune" : "filter_list"
                    }}</mat-icon>
                    @if (hasActiveFilters(widget)) {
                    <span class="filter-active-dot"></span>
                    }
                  </button>
                  } @if (editMode && canEdit) {
                  <button
                    mat-icon-button
                    (click)="editWidget(widget.id)"
                    class="widget-action-button"
                  >
                    <mat-icon>settings</mat-icon>
                  </button>
                  } @if (editMode && canEdit) {
                  <button
                    mat-icon-button
                    color="warn"
                    (click)="removeWidget(widget.id)"
                    class="widget-action-button"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                  }
                </div>
              </ng-container>
            </div>
            <!-- Widget content section with loading indicator -->
            <div class="widget-content">
              <!-- User Progress Widget -->
              @if (widget.type === 'userProgress') {
              <div class="user-progress-widget">
                <!-- Loading indicator overlays just the content, not the header -->
                @if (isProgressListLoading(widget)) {
                <div class="widget-loading">
                  <div class="loading-spinner-small"></div>
                  <p>Indlæser data...</p>
                </div>
                }
                <!-- User list area - still rendered but potentially hidden by loading overlay -->
                <div
                  class="user-list"
                  (scroll)="onWidgetScroll($event, widget)"
                  [style.overflow-y]="'auto'"
                >
                  @for (user of getFilteredUsers(widget); track
                  trackByUserId($index, user)) {
                  <div
                    class="user-item"
                    (click)="navigateToUserProfile(user)"
                    [style.cursor]="'pointer'"
                  >
                    <div
                      class="user-info"
                      [attr.title]="
                        'Klik for at se ' + (user?.name || 'bruger') + 's profil'
                      "
                    >
                      <div class="user-avatar-container">
                        <div class="user-avatar">
                          {{ user?.name ? user.name.charAt(0) : "" }}
                        </div>
                        <app-duna-validation-indicator
                          [status]="getUserValidationStatus(user)"
                          [customTooltip]="getUserValidationTooltip(user)"
                        >
                        </app-duna-validation-indicator>
                      </div>
                      <div class="user-details">
                        <h4 class="user-name">{{ user?.name || "No name" }}</h4>
                        <div class="user-meta">
                          <div class="meta-item-combined">
                            <mat-icon class="meta-icon">home</mat-icon>
                            <span class="user-station">{{
                              user?.station || ""
                            }}</span>
                            <mat-icon class="meta-icon">school</mat-icon>
                            <span class="user-path">{{
                              user?.path || ""
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="user-progress" (click)="$event.stopPropagation()">
                      <app-duna-user-progress-label
                        [registeredPercentage]="
                          user?.progressLabel?.registeredPercentage ??
                          user?.registeredPercentage
                        "
                        [progressPercentage]="
                          user?.progressLabel?.progressPercentage ??
                          user?.progress_percentage ??
                          user?.percentComplete ??
                          0
                        "
                        [paths]="user?.progressLabel?.paths ?? user?.paths"
                        [totals]="
                          user?.progressLabel?.totals ?? {
                            maintenance_minutes_required_total:
                              user?.maintenance_minutes_required_total,
                            maintenance_minutes_completed_total:
                              user?.maintenance_minutes_completed_total,
                            maintenance_minutes_intended_total:
                              user?.maintenance_minutes_intended_total,
                            registered_percentage: user?.registeredPercentage,
                            progress_percentage:
                              user?.progress_percentage || user?.percentComplete
                          }
                        "
                        [year]="currentYear"
                        [compact]="true"
                        aggregateContext="user"
                      ></app-duna-user-progress-label>
                    </div>
                  </div>
                  }
                  <!-- Loading more indicator -->
                  @if (isProgressListLoadMoreUiVisible(widget)) {
                  <div
                    class="loading-spinner-small"
                    style="margin: 16px auto"
                  ></div>
                  }
                  <!-- No data message - show only when not loading and no users -->
                  @if (isProgressListEmpty(widget)) {
                  <div class="no-data">
                    <p>Ingen brugerdata</p>
                  </div>
                  }
                </div>
              </div>
              }
              <!-- User Progress Stats Widget -->
              @if (widget.type === 'userProgressStats') {
              <div class="user-progress-stats-widget">
                <!-- Loading indicator overlays just the content, not the header -->
                @if (widget.isLoading) {
                <div class="widget-loading">
                  <div class="loading-spinner-small"></div>
                  <p>Indlæser statistik data...</p>
                </div>
                }
                <!-- Statistics visualization -->
                @if (!widget.isLoading) {
                <div class="stats-visualization">
                  @if (widget.data?.users && widget.data.users.length > 0) {
                  <!-- Dual donut chart showing both registered and progress averages -->
                  <div class="donut-chart-container">
                    <svg viewBox="0 0 200 200" class="progress-donut-chart">
                      <!-- Outer ring background -->
                      <circle
                        cx="100"
                        cy="100"
                        r="75"
                        fill="none"
                        stroke="#f0f0f0"
                        stroke-width="8"
                      ></circle>
                      <!-- Inner ring background -->
                      <circle
                        cx="100"
                        cy="100"
                        r="60"
                        fill="none"
                        stroke="#f0f0f0"
                        stroke-width="8"
                      ></circle>
                      <!-- Outer ring: Registered percentage -->
                      <circle
                        cx="100"
                        cy="100"
                        r="75"
                        fill="none"
                        stroke="#2196f3"
                        stroke-width="8"
                        stroke-opacity="0.7"
                        [attr.stroke-dasharray]="
                          getAverageRegistered(widget) * 4.71 + ' 471'
                        "
                        stroke-dashoffset="0"
                        transform="rotate(-90, 100, 100)"
                        [attr.title]="
                          'Gennemsnitlig registreret: ' +
                          getAverageRegistered(widget) +
                          '%'
                        "
                      ></circle>
                      <!-- Inner ring: Progress percentage -->
                      <circle
                        cx="100"
                        cy="100"
                        r="60"
                        fill="none"
                        stroke="#4caf50"
                        stroke-width="8"
                        [attr.stroke-dasharray]="
                          getAverageActualProgress(widget) * 3.77 + ' 377'
                        "
                        stroke-dashoffset="0"
                        transform="rotate(-90, 100, 100)"
                        [attr.title]="
                          'Gennemsnitlig fremgang: ' +
                          getAverageActualProgress(widget) +
                          '%'
                        "
                      ></circle>
                      <!-- Center text with both averages -->
                      <text
                        x="100"
                        y="88"
                        text-anchor="middle"
                        font-size="14"
                        font-weight="bold"
                        fill="#2196f3"
                        fill-opacity="0.8"
                      >
                        {{ getAverageRegistered(widget) }}% Reg.
                      </text>
                      <text
                        x="100"
                        y="106"
                        text-anchor="middle"
                        font-size="14"
                        font-weight="bold"
                        fill="#4caf50"
                      >
                        {{ getAverageActualProgress(widget) }}% Frem.
                      </text>
                      <text
                        x="100"
                        y="122"
                        text-anchor="middle"
                        font-size="10"
                        fill="#666"
                      >
                        Gennemsnit
                      </text>
                    </svg>
                  </div>
                  <!-- Progress distribution -->
                  <div class="progress-distribution">
                    <h4>Fremgang Fordeling</h4>
                    <div class="distribution-bars">
                      @for (range of getProgressRanges(widget); track range.label) {
                      <div class="distribution-item">
                        <div class="range-label">{{ range.label }}</div>
                        <div class="range-bar side-by-side-bars">
                          <div class="bar-container">
                            <div class="bar-label">Reg.</div>
                            <div class="bar-track">
                              <div
                                class="range-registered"
                                [style.width]="range.registeredPercentage + '%'"
                                [style.background-color]="range.color"
                                [style.opacity]="'0.7'"
                                title="{{
                                  range.registeredCount
                                }} brugere registreret ({{
                                  range.registeredPercentage
                                }}%)"
                              ></div>
                            </div>
                          </div>
                          <div class="bar-container">
                            <div class="bar-label">Frem.</div>
                            <div class="bar-track">
                              <div
                                class="range-progress"
                                [style.width]="range.progressPercentage + '%'"
                                [style.background-color]="range.color"
                                title="{{
                                  range.progressCount
                                }} brugere med fremgang ({{
                                  range.progressPercentage
                                }}%)"
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div class="range-count">
                          <span class="registered-count"
                            >{{ range.registeredCount }} reg.</span
                          >
                          <span class="progress-count"
                            >{{ range.progressCount }} frem.</span
                          >
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                  <!-- Summary statistics -->
                  <div class="summary-stats">
                    <div class="stat-item">
                      <div class="stat-value">
                        {{ widget.data.users.length }}
                      </div>
                      <div class="stat-label">Total Brugere</div>
                    </div>
                    <div class="stat-item">
                      <div class="stat-value">
                        {{ getCompletedCount(widget) }}
                      </div>
                      <div class="stat-label">Fuldført</div>
                    </div>
                    <div class="stat-item">
                      <div class="stat-value">
                        {{ getInProgressCount(widget) }}
                      </div>
                      <div class="stat-label">I Gang</div>
                    </div>
                    <div class="stat-item">
                      <div class="stat-value">
                        {{ getNotStartedCount(widget) }}
                      </div>
                      <div class="stat-label">Ikke Startet</div>
                    </div>
                  </div>
                  }
                  <!-- No data message -->
                  @if (!widget.data?.users || widget.data.users.length === 0) {
                  <div class="no-data">
                    <p>Ingen brugerstatistik data</p>
                  </div>
                  }
                </div>
                }
              </div>
              }
              <!-- Location Progress Widget -->
              @if (widget.type === 'locationProgress') {
              <div class="location-progress-widget">
                <!-- Loading indicator overlays just the content, not the header -->
                @if (isProgressListLoading(widget)) {
                <div class="widget-loading">
                  <div class="loading-spinner-small"></div>
                  <p>Indlæser lokations data...</p>
                </div>
                }
                <!-- Location list area - still rendered but potentially hidden by loading overlay -->
                <div
                  class="location-list"
                  (scroll)="onWidgetScroll($event, widget)"
                  [style.overflow-y]="'auto'"
                >
                  @for (location of getFilteredLocations(widget); track
                  trackByLocationId($index, location)) {
                  <div
                    class="location-item"
                    (click)="navigateToLocationDetails(location)"
                    [style.cursor]="'pointer'"
                  >
                    <div
                      class="location-info"
                      [attr.title]="
                        'Klik for at se ' +
                        (location?.name || 'lokation') +
                        ' detaljer'
                      "
                    >
                      <div class="location-avatar">
                        {{ location?.name ? location.name.charAt(0) : "" }}
                      </div>
                      <div class="location-details">
                        <h4 class="location-name">
                          {{ location?.name || "No name" }}
                        </h4>
                        <div class="location-meta">
                          <div class="meta-item">
                            <mat-icon class="meta-icon">home</mat-icon>
                            <span class="location-type">Lokation</span>
                          </div>
                          <div class="meta-item">
                            <mat-icon class="meta-icon">person</mat-icon>
                            <span class="location-users"
                              >{{ location?.userCount || 0 }} Brugere</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="location-progress" (click)="$event.stopPropagation()">
                      <app-duna-user-progress-label
                        [registeredPercentage]="
                          location?.registeredPercentage ||
                          location?.averageProgress ||
                          location?.registered_percentage ||
                          0
                        "
                        [progressPercentage]="
                          location?.progress_percentage ||
                          location?.completionRate ||
                          0
                        "
                        [showBreakdown]="false"
                        [compact]="true"
                        aggregateContext="location"
                      ></app-duna-user-progress-label>
                    </div>
                  </div>
                  }
                  <!-- Loading more indicator -->
                  @if (isProgressListLoadMoreUiVisible(widget)) {
                  <div
                    class="loading-spinner-small"
                    style="margin: 16px auto"
                  ></div>
                  }
                  <!-- No data message - show only when not loading and no locations -->
                  @if (isProgressListEmpty(widget)) {
                  <div class="no-data">
                    <p>Ingen lokationsdata</p>
                  </div>
                  }
                </div>
              </div>
              }
              <!-- Status Widget -->
              @if (widget.type === 'userStatus' && !widget.isLoading) {
              <div class="status-widget">
                <!-- SVG donut chart -->
                <div class="donut-chart-container">
                  <svg viewBox="0 0 100 100" class="donut-chart">
                    <!-- Background circle -->
                    <circle
                      cx="50"
                      cy="50"
                      r="40"
                      fill="none"
                      stroke="#f0f0f0"
                      stroke-width="10"
                    ></circle>
                    <!-- Completion progress circle -->
                    <circle
                      cx="50"
                      cy="50"
                      r="40"
                      fill="none"
                      stroke="#4caf50"
                      stroke-width="10"
                      [attr.stroke-dasharray]="
                        (widget.data?.percentComplete || 0) * 2.51 + ' 251'
                      "
                      stroke-dashoffset="0"
                      transform="rotate(-90, 50, 50)"
                    ></circle>
                    <!-- Center text with percentage -->
                    <text
                      x="50"
                      y="45"
                      text-anchor="middle"
                      font-size="16"
                      font-weight="bold"
                    >
                      {{ widget.data?.percentComplete || 0 }}%
                    </text>
                    <text x="50" y="60" text-anchor="middle" font-size="8">
                      Complete
                    </text>
                  </svg>
                </div>
                <!-- Status details -->
                <div class="status-details">
                  <div class="status-item">
                    <span class="status-value">{{
                      widget.data?.completedUsers || 0
                    }}</span>
                    <span class="status-label">Completed</span>
                  </div>
                  <div class="status-item">
                    <span class="status-value">{{
                      widget.data?.totalUsers || 0
                    }}</span>
                    <span class="status-label">Total</span>
                  </div>
                </div>
                <!-- Status distribution bar -->
                @if (widget.data?.statusDistribution?.length > 0) {
                <div class="status-distribution">
                  <div class="status-bar">
                    <div
                      class="status-segment completed"
                      [style.flex-basis]="
                        ((widget.data?.completedUsers || 0) /
                          (widget.data?.totalUsers || 1)) *
                          100 +
                        '%'
                      "
                      [attr.title]="
                        widget.data?.completedUsers + ' users completed'
                      "
                    ></div>
                    <div
                      class="status-segment in-progress"
                      [style.flex-basis]="
                        ((widget.data?.inProgressUsers || 0) /
                          (widget.data?.totalUsers || 1)) *
                          100 +
                        '%'
                      "
                      [attr.title]="
                        widget.data?.inProgressUsers + ' users in progress'
                      "
                    ></div>
                    <div
                      class="status-segment not-started"
                      [style.flex-basis]="
                        ((widget.data?.notStartedUsers || 0) /
                          (widget.data?.totalUsers || 1)) *
                          100 +
                        '%'
                      "
                      [attr.title]="
                        widget.data?.notStartedUsers + ' users not started'
                      "
                    ></div>
                  </div>
                  <div class="status-legend">
                    <div class="legend-item">
                      <span class="legend-color completed"></span>
                      <span class="legend-label">Completed</span>
                    </div>
                    <div class="legend-item">
                      <span class="legend-color in-progress"></span>
                      <span class="legend-label">In Progress</span>
                    </div>
                    <div class="legend-item">
                      <span class="legend-color not-started"></span>
                      <span class="legend-label">Not Started</span>
                    </div>
                  </div>
                </div>
                }
              </div>
              }
              <!-- Upcoming Exercises Widget -->
              @if (widget.type === 'upcomingExercises') {
              <div class="exercises-widget">
                @if (widget.data && widget.data.exercises &&
                widget.data.exercises.length > 0) { @for (exercise of
                widget.data.exercises; track exercise.id ?? exercise.date ?? $index) {
                <div class="exercise-item">
                  <div class="exercise-date">
                    <span class="date-day">{{
                      $safeNavigationMigration(exercise?.date) | date : "d"
                    }}</span>
                    <span class="date-month">{{
                      $safeNavigationMigration(exercise?.date) | date : "MMM"
                    }}</span>
                  </div>
                  <div class="exercise-details">
                    <h4 class="exercise-title">
                      {{ exercise?.title || "No title" }}
                    </h4>
                    <p class="exercise-location">
                      {{ exercise?.location || "" }}
                    </p>
                  </div>
                </div>
                } } @else {
                <div class="no-data">
                  <p>Ingen øvelser planlagt</p>
                </div>
                }
              </div>
              }
              <!-- Quick Links Widget -->
              @if (widget.type === 'quickLinks') {
              <div class="quick-links-widget">
                @if (widget.data && widget.data.links &&
                widget.data.links.length > 0) {
                <div class="links-grid">
                  @for (link of widget.data.links; track link.url ?? link.title ?? $index) {
                  <a [href]="link?.url || '#'" class="quick-link">
                    <div class="link-icon">
                      <mat-icon>{{ link?.icon || "link" }}</mat-icon>
                    </div>
                    <span class="link-text">{{ link?.title || "Link" }}</span>
                  </a>
                  }
                </div>
                } @else {
                <div class="no-data">
                  <p>Ingen links tilføjet</p>
                </div>
                }
              </div>
              }
              <!-- Reminders Widget -->
              @if (widget.type === 'reminders') {
              <div class="reminders-widget">
                @if (widget.data && widget.data.reminders &&
                widget.data.reminders.length > 0) {
                <div class="reminder-list">
                  @for (reminder of widget.data.reminders; track reminder.id ?? reminder.title ?? $index) {
                  <div class="reminder-item">
                    <div class="reminder-checkbox">
                      <mat-icon>{{
                        reminder?.completed
                          ? "check_circle"
                          : "radio_button_unchecked"
                      }}</mat-icon>
                    </div>
                    <div class="reminder-content">
                      <h4 class="reminder-title">
                        {{ reminder?.title || "No title" }}
                      </h4>
                      <p class="reminder-date">
                        {{ $safeNavigationMigration(reminder?.dueDate) | date }}
                      </p>
                    </div>
                  </div>
                  }
                </div>
                } @else {
                <div class="no-data">
                  <p>Ingen påmindelser</p>
                </div>
                }
              </div>
              }
              <!-- Year Comparison Widget -->
              @if (widget.type === 'yearComparison') {
              <div class="year-comparison-widget">
                @if (widget.data && widget.data.comparison &&
                widget.data.comparison.length > 0) {
                <div class="chart-container">
                  <canvas [id]="'chart-' + widget.id" #chartCanvas></canvas>
                </div>
                <div class="comparison-summary">
                  @if (widget.data && widget.data.metrics &&
                  widget.data.metrics.length > 0) {
                  <div class="grid-cols-4 grid gap-2 mt-3">
                    @for (metric of widget.data.metrics; track metric.name ?? $index) {
                    <div class="bg-gray-50 rounded-lg p-3">
                      <div class="text-xs text-gray-500">
                        {{ metric?.name || "" }}
                      </div>
                      <div class="flex justify-between items-baseline mt-1">
                        <div class="font-medium">
                          {{ metric?.thisYear || 0 }}
                          <span class="text-xs text-gray-500"
                            >vs {{ metric?.lastYear || 0 }}</span
                          >
                        </div>
                        <div
                          [ngClass]="
                            metric?.percentChange >= 0
                              ? 'text-green-600'
                              : 'text-red-600'
                          "
                          class="text-sm"
                        >
                          {{ metric?.percentChange >= 0 ? "+" : ""
                          }}{{ metric?.percentChange || 0 }}%
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                  }
                </div>
                } @else {
                <div class="no-data">
                  <p>Ingen sammenligningsdata</p>
                </div>
                }
              </div>
              }
              <!-- Simple Number Widget -->
              @if (widget.type === 'simpleNumber') {
              <div class="simple-number-widget">
                <!-- Loading indicator overlays just the content, not the header -->
                @if (widget.isLoading) {
                <div class="widget-loading">
                  <div class="loading-spinner-small"></div>
                  <p>Indlæser tal...</p>
                </div>
                }
                <!-- Number display -->
                @if (!widget.isLoading) {
                <div class="number-display">
                  {{ widget.data?.value || 0 }}
                </div>
                } @if (!widget.isLoading && widget.data?.title) {
                <div class="number-title">
                  <span>{{ widget.data.title }}</span>
                  @if (widget.data?.subtitle && widget.dataSource ===
                  'registered_to_progress_ratio') {
                  <mat-icon class="info-icon" [title]="widget.data.subtitle">
                    info
                  </mat-icon>
                  }
                </div>
                } @if (!widget.isLoading && widget.data?.trend &&
                widget.data.trend.percentage > 0) {
                <div
                  class="trend-indicator"
                  [ngClass]="'trend-' + widget.data.trend.direction"
                >
                  <mat-icon class="trend-icon">{{
                    widget.data.trend.direction === "up"
                      ? "trending_up"
                      : widget.data.trend.direction === "down"
                      ? "trending_down"
                      : "trending_flat"
                  }}</mat-icon>
                  <span>{{ widget.data.trend.percentage }}%</span>
                </div>
                }
              </div>
              }
              <!-- Number Stats Widget -->
              @if (widget.type === 'numberStats') {
              <div class="number-stats-widget">
                <div class="stats-content">
                  @if (widget.data?.title) {
                  <h3 class="stats-title">{{ widget.data?.title }}</h3>
                  }
                  <div class="stats-value-container">
                    <div class="primary-value">
                      <span>{{ widget.data?.value || 0 }}</span>
                      @if (widget.data?.showAsFraction &&
                      widget.data?.secondaryValue) {
                      <span
                        >/{{
                          widget.data?.value - widget.data?.secondaryValue
                        }}</span
                      >
                      }
                    </div>
                    @if (widget.data?.secondaryValue &&
                    !widget.data?.showAsFraction) {
                    <div class="secondary-value">
                      <span class="secondary-label"
                        >{{ widget.data?.secondaryLabel || "Heraf" }}:</span
                      >
                      <span class="secondary-number">{{
                        widget.data?.secondaryValue
                      }}</span>
                    </div>
                    }
                  </div>
                  @if ($safeNavigationMigration(widget.data?.percentComplete)
                  !== undefined) {
                  <div class="stats-progress">
                    <div class="progress-bar">
                      <div
                        class="progress-value"
                        [style.width]="widget.data?.percentComplete + '%'"
                      ></div>
                    </div>
                    <span class="progress-label"
                      >{{ widget.data?.percentComplete }}%</span
                    >
                  </div>
                  }
                </div>
              </div>
              }
              @if (widget.type === 'eventsCalendar') {
              <app-duna-dashboard-events-calendar-widget
                [filters]="widget.settings?.filters || {}"
                [reloadToken]="widget.eventsCalendarReloadToken || 0"
                (filtersChange)="onEventsCalendarFiltersChange(widget, $event)"
              />
              }
              <!-- Catering Summary Widget -->
              @if (widget.type === 'cateringSummary') {
              <app-duna-catering-summary-widget
                [data]="widget.data"
                [isLoading]="!!widget.isLoading"
                [fillHeight]="true"
                [showPdfDownload]="true"
                (openPreferences)="openCateringPreferences($event)"
                (navigateToEvent)="navigateToEvent($event)"
              >
              </app-duna-catering-summary-widget>
              }
              <!-- Fallback for unknown widget types -->
              @if (!['userStatus', 'status', 'upcomingExercises', 'quickLinks',
              'userProgress', 'locationProgress', 'userProgressStats',
              'reminders', 'yearComparison', 'numberStats', 'simpleNumber',
              'cateringSummary', 'eventsCalendar'].includes(widget.type)) {
              <div class="no-data">
                <p>Widget type {{ widget.type }} not available</p>
              </div>
              }
            </div>
          </div>
        </gridster-item>
        }
      </gridster>
      }
    </div>
    }
  </div>
</div>

<!-- Widget Settings Dialog (CDK Overlay — above site header) -->
<ng-template #settingsDialogTemplate>
@if (selectedWidget) {
<div class="settings-dialog">
  <div class="settings-header">
    <h2>Indstillinger: {{ selectedWidget.title }}</h2>
    <button class="close-btn" (click)="closeSettings()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="settings-tabs">
    <button
      [class.active]="activeSettingsTab === 'general'"
      (click)="setActiveSettingsTab('general')"
    >
      Generelt
    </button>
    @if (hasSettingsFiltersTab(selectedWidget.type)) {
    <button
      [class.active]="activeSettingsTab === 'filters'"
      (click)="setActiveSettingsTab('filters')"
    >
      Filtrering
    </button>
    }
    @if (hasSettingsDisplayTab(selectedWidget.type)) {
    <button
      [class.active]="activeSettingsTab === 'display'"
      (click)="setActiveSettingsTab('display')"
    >
      Visning
    </button>
    }
    <button
      [class.active]="activeSettingsTab === 'export'"
      (click)="setActiveSettingsTab('export')"
    >
      Exportering
    </button>
  </div>
  <div class="settings-content">
    <!-- General settings -->
    @if (activeSettingsTab === 'general') {
    <div class="settings-section">
      <div class="form-group">
        <label for="widget-title">Titel</label>
        <input
          type="text"
          id="widget-title"
          [(ngModel)]="selectedWidget.title"
          placeholder="Widget titel"
        />
      </div>
      <!-- Widget-specific settings can be added here -->
    </div>
    }
    <!-- Filter settings -->
    @if (activeSettingsTab === 'filters') {
    <div class="settings-section">
      <!-- User Progress filters -->
      @if (selectedWidget.type === 'userProgress') {
      <div class="filter-section">
        <!-- Data Source Selection -->
        <div class="form-group">
          <label for="data-source">Datakilde</label>
          <select id="data-source" [(ngModel)]="selectedWidget.dataSource">
            <option value="user_progress">Brugerfremdrift</option>
            <option value="user_attendance">Brugertilstedeværelse</option>
            <option value="user_certifications">Brugercertificeringer</option>
          </select>
        </div>
      </div>
      }
      <!-- User Progress Stats filters -->
      @if (selectedWidget.type === 'userProgressStats') {
      <div class="filter-section">
        <!-- Data Source Selection -->
        <div class="form-group">
          <label for="data-source-stats">Datakilde</label>
          <select
            id="data-source-stats"
            [(ngModel)]="selectedWidget.dataSource"
            (change)="onDataSourceChange(selectedWidget)"
          >
            <option value="user_progress">Brugerfremdrift</option>
            <option value="user_attendance">Brugertilstedeværelse</option>
            <option value="user_certifications">Brugercertificeringer</option>
          </select>
        </div>
      </div>
      }
      <!-- Location Progress filters -->
      @if (selectedWidget.type === 'locationProgress') {
      <div class="filter-section">
        <!-- Data Source Selection -->
        <div class="form-group">
          <label for="data-source-location">Datakilde</label>
          <select
            id="data-source-location"
            [(ngModel)]="selectedWidget.dataSource"
            (change)="onDataSourceChange(selectedWidget)"
          >
            <option value="location_progress">Lokationsfremdrift</option>
            <option value="location_attendance">
              Lokationstilstedeværelse
            </option>
            <option value="location_certifications">
              Lokationscertificeringer
            </option>
          </select>
        </div>
      </div>
      }
      <!-- Reminders filters -->
      @if (selectedWidget.type === 'reminders') {
      <div class="filter-section">
        <div class="form-group">
          <label for="data-source-reminders">Datakilde</label>
          <select
            id="data-source-reminders"
            [(ngModel)]="selectedWidget.dataSource"
          >
            <option value="user_reminders">Brugerpåmindelser</option>
            <option value="system_reminders">Systempåmindelser</option>
          </select>
        </div>
      </div>
      }
      <!-- Year Comparison filters -->
      @if (selectedWidget.type === 'yearComparison') {
      <div class="filter-section">
        <div class="form-group">
          <label for="data-source-year">Datakilde</label>
          <select id="data-source-year" [(ngModel)]="selectedWidget.dataSource">
            <option value="exercise_comparison">Øvelsessammenligning</option>
            <option value="certification_comparison">
              Certificeringssammenligning
            </option>
            <option value="attendance_comparison">Fremmødesammenligning</option>
          </select>
        </div>
      </div>
      }
      <!-- Quick Links filters -->
      @if (selectedWidget.type === 'quickLinks') {
      <div class="filter-section">
        <div class="form-group">
          <label for="data-source-links">Datakilde</label>
          <select
            id="data-source-links"
            [(ngModel)]="selectedWidget.dataSource"
          >
            <option value="default_links">Standard links</option>
            <option value="admin_links">Admin links</option>
            <option value="user_links">Brugerlinks</option>
          </select>
        </div>
      </div>
      }
      <!-- Status filters -->
      @if (selectedWidget.type === 'status') {
      <div class="filter-section">
        <div class="form-group">
          <label for="data-source-status">Datakilde</label>
          <select
            id="data-source-status"
            [(ngModel)]="selectedWidget.dataSource"
          >
            <option value="user_status">Brugerstatus</option>
            <option value="system_status">Systemstatus</option>
            <option value="organization_status">Organisationsstatus</option>
          </select>
        </div>
      </div>
      }
      <!-- Upcoming Exercises filters -->
      @if (selectedWidget.type === 'upcomingExercises') {
      <div class="filter-section">
        <div class="form-group">
          <label for="data-source-exercises">Datakilde</label>
          <select
            id="data-source-exercises"
            [(ngModel)]="selectedWidget.dataSource"
          >
            <option value="scheduled_exercises">Planlagte øvelser</option>
            <option value="mandatory_exercises">Obligatoriske øvelser</option>
            <option value="optional_exercises">Valgfrie øvelser</option>
          </select>
        </div>
      </div>
      }
      <!-- Number Stats filters -->
      @if (selectedWidget.type === 'numberStats') {
      <div class="filter-section">
        <div class="form-group">
          <label for="data-source-stats">Datakilde</label>
          <select
            id="data-source-stats"
            [(ngModel)]="selectedWidget.dataSource"
          >
            <option value="user_stats">Brugerstatistik</option>
            <option value="location_stats">Lokationsstatistik</option>
            <option value="exercise_stats">Øvelsesstatistik</option>
            <option value="course_stats">Kursusstatistik</option>
          </select>
        </div>
      </div>
      }
      <!-- Simple Number filters -->
      @if (selectedWidget.type === 'simpleNumber') {
      <div class="filter-section">
        <div class="form-group">
          <label for="data-source-simple-number">Metrik</label>
          <select
            id="data-source-simple-number"
            [(ngModel)]="selectedWidget.dataSource"
            (change)="onDataSourceChange(selectedWidget)"
          >
            <option value="simple_number">Total Brugere</option>
            <option value="user_count">Aktive Brugere</option>
            <option value="completion_rate">Gennemsnitlig Fremgang</option>
            <option value="completed_users">Færdige Brugere</option>
            <option value="users_with_warnings">Brugere med Advarsler</option>
            <option value="registered_to_progress_ratio">
              Registreret/Fremgang Ratio
            </option>
          </select>
        </div>
      </div>
      }
    </div>
    }
    <!-- Display settings -->
    @if (activeSettingsTab === 'display') {
    <div class="settings-section">
      @if (hasDisplayTypeOptions(selectedWidget.type)) {
      <div class="form-group">
        <label for="display-type">Visningstype</label>
        <select
          id="display-type"
          [(ngModel)]="selectedWidget.settings!.displayType"
        >
          @if (['upcomingExercises', 'userProgress', 'locationProgress',
          'userProgressStats', 'reminders'].includes(selectedWidget.type)) {
          <option value="table">Tabel</option>
          } @if (['status', 'yearComparison'].includes(selectedWidget.type)) {
          <option value="chart">Graf</option>
          } @if (['quickLinks'].includes(selectedWidget.type)) {
          <option value="buttons">Knapper</option>
          } @if (['reminders'].includes(selectedWidget.type)) {
          <option value="list">Liste</option>
          } @if (['status'].includes(selectedWidget.type)) {
          <option value="tile">Felt</option>
          } @if (['numberStats'].includes(selectedWidget.type)) {
          <option value="single">Enkelt tal</option>
          } @if (['numberStats'].includes(selectedWidget.type)) {
          <option value="fraction">Brøk</option>
          }
        </select>
      </div>
      }
      @if (hasDisplayFieldSettings(selectedWidget.type)) {
      <div class="form-group">
        <label>Viste felter</label>
        <div class="field-checkboxes">
          <!-- Status fields -->
          @if (selectedWidget.type === 'status') {
          <div>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('percentComplete')"
                [checked]="
                  selectedWidget.settings!.fields.includes('percentComplete')
                "
              />
              Procent færdig
            </label>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('totalUsers')"
                [checked]="
                  selectedWidget.settings!.fields.includes('totalUsers')
                "
              />
              Total brugere
            </label>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('completedUsers')"
                [checked]="
                  selectedWidget.settings!.fields.includes('completedUsers')
                "
              />
              Færdige brugere
            </label>
          </div>
          }
          <!-- Upcoming Exercises fields -->
          @if (selectedWidget.type === 'upcomingExercises') {
          <div>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('name')"
                [checked]="selectedWidget.settings!.fields.includes('name')"
              />
              Navn
            </label>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('date')"
                [checked]="selectedWidget.settings!.fields.includes('date')"
              />
              Dato
            </label>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('location')"
                [checked]="selectedWidget.settings!.fields.includes('location')"
              />
              Lokation
            </label>
          </div>
          }
          <!-- Number Stats fields -->
          @if (selectedWidget.type === 'numberStats') {
          <div>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('title')"
                [checked]="selectedWidget.settings!.fields.includes('title')"
              />
              Titel
            </label>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('value')"
                [checked]="selectedWidget.settings!.fields.includes('value')"
              />
              Primær værdi
            </label>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('secondaryValue')"
                [checked]="
                  selectedWidget.settings!.fields.includes('secondaryValue')
                "
              />
              Sekundær værdi
            </label>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('percentComplete')"
                [checked]="
                  selectedWidget.settings!.fields.includes('percentComplete')
                "
              />
              Procent bar
            </label>
          </div>
          }
          <!-- Location Progress fields -->
          @if (selectedWidget.type === 'locationProgress') {
          <div>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('name')"
                [checked]="selectedWidget.settings!.fields.includes('name')"
              />
              Lokationsnavn
            </label>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('userCount')"
                [checked]="
                  selectedWidget.settings!.fields.includes('userCount')
                "
              />
              Antal brugere
            </label>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('averageProgress')"
                [checked]="
                  selectedWidget.settings!.fields.includes('averageProgress')
                "
              />
              Gennemsnitlig fremgang
            </label>
            <label class="field-checkbox">
              <input
                type="checkbox"
                (change)="toggleField('completionRate')"
                [checked]="
                  selectedWidget.settings!.fields.includes('completionRate')
                "
              />
              Fuldførelsesrate
            </label>
          </div>
          }
          <!-- Sort Quick Filters - Only for userProgress, not userProgressStats -->
          @if (selectedWidget.type === 'userProgress') {
          <div class="quick-filter-section">
            <h3>Sortér efter</h3>
            <div class="quick-filter-chips">
              <div
                class="filter-chip"
                [class.active]="selectedWidget.settings!.filters['sortBy'] === 'name'"
                (click)="sortUserProgressData(selectedWidget, 'name')"
              >
                <mat-icon>sort_by_alpha</mat-icon>
                <span>Navn</span>
                @if (selectedWidget.settings!.filters['sortBy'] === 'name') {
                <mat-icon class="direction-icon">
                  {{ selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
                }
              </div>
              <div
                class="filter-chip"
                [class.active]="selectedWidget.settings!.filters['sortBy'] === 'station'"
                (click)="sortUserProgressData(selectedWidget, 'station')"
              >
                <mat-icon>location_on</mat-icon>
                <span>Station</span>
                @if (selectedWidget.settings!.filters['sortBy'] === 'station')
                {
                <mat-icon class="direction-icon">
                  {{ selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
                }
              </div>
              <div
                class="filter-chip"
                [class.active]="selectedWidget.settings!.filters['sortBy'] === 'path'"
                (click)="sortUserProgressData(selectedWidget, 'path')"
              >
                <mat-icon>school</mat-icon>
                <span>Uddannelsesvej</span>
                @if (selectedWidget.settings!.filters['sortBy'] === 'path') {
                <mat-icon class="direction-icon">
                  {{ selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
                }
              </div>
              <div
                class="filter-chip"
                [class.active]="selectedWidget.settings!.filters['sortBy'] === 'registeredPercentage'"
                (click)="
                  sortUserProgressData(selectedWidget, 'registeredPercentage')
                "
              >
                <mat-icon>assignment</mat-icon>
                <span>Registreret</span>
                @if (selectedWidget.settings!.filters['sortBy'] ===
                'registeredPercentage') {
                <mat-icon class="direction-icon">
                  {{ selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
                }
              </div>
              <div
                class="filter-chip"
                [class.active]="selectedWidget.settings!.filters['sortBy'] === 'percentComplete'"
                (click)="
                  sortUserProgressData(selectedWidget, 'percentComplete')
                "
              >
                <mat-icon>trending_up</mat-icon>
                <span>Fremgang</span>
                @if (selectedWidget.settings!.filters['sortBy'] ===
                'percentComplete') {
                <mat-icon class="direction-icon">
                  {{ selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
                }
              </div>
              <div
                class="filter-chip"
                [class.active]="selectedWidget.settings!.filters['sortBy'] === 'status'"
                (click)="sortUserProgressData(selectedWidget, 'status')"
              >
                <mat-icon>info</mat-icon>
                <span>Status</span>
                @if (selectedWidget.settings!.filters['sortBy'] === 'status')
                {
                <mat-icon class="direction-icon">
                  {{ selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
    }
    <!-- Export settings -->
    @if (activeSettingsTab === 'export') {
    <div class="settings-section">
      <div class="form-group">
        <label for="export-format">Eksport format</label>
        <select id="export-format" [(ngModel)]="selectedExportFormat">
          <option value="excel">Excel (.xlsx)</option>
          <option value="pdf">PDF (.pdf)</option>
          <option value="csv">CSV (.csv)</option>
        </select>
      </div>
      <div class="form-group">
        <label>Eksport indstillinger</label>
        <div class="checkbox-group">
          <label>
            <input type="checkbox" [(ngModel)]="exportIncludeHeaders" checked />
            Inkluder kolonneoverskrifter
          </label>
          <label>
            <input type="checkbox" [(ngModel)]="exportIncludeFilters" />
            Inkluder filteroplysninger
          </label>
          @if (selectedExportFormat === 'pdf') {
          <label>
            <input type="checkbox" [(ngModel)]="exportIncludeLogo" />
            Inkluder logo/titel
          </label>
          }
        </div>
      </div>
      <div class="form-group">
        <label for="export-filename">Filnavn (valgfrit)</label>
        <input
          type="text"
          id="export-filename"
          [(ngModel)]="customExportFilename"
          placeholder="Efterlad tom for automatisk navn"
        />
      </div>
      <div class="export-preview">
        <p class="info-text">
          <mat-icon>info</mat-icon>
          @if (selectedExportFormat === 'excel') {
          <span>
            Excel filen vil indeholde alle synlige data med formatering og kan
            åbnes i Microsoft Excel eller lignende programmer.
          </span>
          } @if (selectedExportFormat === 'pdf') {
          <span>
            PDF filen vil være formateret til print og indeholde en tabel med
            widget data.
          </span>
          } @if (selectedExportFormat === 'csv') {
          <span>
            CSV filen kan importeres i andre systemer og åbnes i Excel. Ingen
            formatering medtages.
          </span>
          }
        </p>
        <div class="export-stats">
          <small>
            <strong>Data at eksportere:</strong>
            {{ getExportDataCount(selectedWidget) }} rækker @if
            (hasActiveFilters(selectedWidget)) {
            <span> (filtreret data)</span>
            }
          </small>
        </div>
      </div>
      <div class="export-actions">
        <button
          mat-raised-button
          color="primary"
          (click)="exportWidgetData(selectedWidget, selectedExportFormat)"
          [disabled]="!selectedWidget || isExporting"
        >
          @if (!isExporting) {
          <mat-icon>download</mat-icon>
          } @if (isExporting) {
          <mat-icon class="spinning">hourglass_empty</mat-icon>
          }
          {{ isExporting ? "Eksporterer..." : "Eksporter data" }}
        </button>
      </div>
    </div>
    }
  </div>
  <div class="settings-actions">
    <button class="cancel-btn" (click)="closeSettings()">Annuller</button>
    <button
      class="save-btn"
      (click)="
        updateWidgetSettings(selectedWidget!.id!, selectedWidget!.settings!);
        closeSettings()
      "
    >
      Gem
    </button>
  </div>
</div>
}
</ng-template>

<!-- Widget Filter Side-Panel (rendered via CDK Overlay so it appears above nav) -->
<ng-template #filterPanelTemplate>
  @if (selectedWidget) {
  <div class="filter-panel-inner" (click)="$event.stopPropagation()">
    <!-- Panel Header -->
    <div class="filter-panel-header">
      <div class="filter-panel-title">
        <mat-icon>filter_list</mat-icon>
        <span
          >Filtrér: <strong>{{ selectedWidget.title }}</strong></span
        >
      </div>
      <div class="filter-panel-header-actions">
        @if (hasActiveFilters(selectedWidget)) {
        <button
          mat-button
          class="clear-all-btn"
          (click)="clearAllFilters(selectedWidget)"
        >
          <mat-icon>clear_all</mat-icon>
          Nulstil
        </button>
        }
        <button
          mat-icon-button
          (click)="closeFilterDialog()"
          class="filter-close-btn"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <!-- Active Filters Summary Bar -->
    @if (hasActiveFilters(selectedWidget)) {
    <div class="active-filters-bar">
      <span class="active-filters-label">Aktive filtre:</span>
      <div class="active-filter-pills">
        @for (loc of getSelectedStationsFromFilters(selectedWidget.settings!.filters); track loc) {
        <div class="active-pill">
          <mat-icon>location_on</mat-icon>
          <span>{{ loc }}</span>
          <button
            mat-icon-button
            class="pill-remove"
            (click)="
              applyStationsFilter(
                selectedWidget,
                getSelectedStationsFromFilters(selectedWidget.settings!.filters).filter((s) => s !== loc)
              )
            "
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        } @if ((selectedWidget.settings!.filters['educationalPathId'] ?? '')
        !== '' && (selectedWidget.settings!.filters['educationalPathId'] ??
        '') !== 'all') {
        <div class="active-pill">
          <mat-icon>school</mat-icon>
          <span
            >{{getEducationName($safeNavigationMigration(selectedWidget.settings!.filters['educationalPathId'])) || selectedWidget.settings!.filters['educationalPathId']}}</span
          >
          <button
            mat-icon-button
            class="pill-remove"
            (click)="
              applyFilterAndLoad(selectedWidget, 'educationalPathId', '')
            "
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        } @if ((selectedWidget.settings!.filters['groupId'] ?? '') !== '' &&
        (selectedWidget.settings!.filters['groupId'] ?? '') !== 'all') {
        <div class="active-pill">
          <mat-icon>groups</mat-icon>
          <span
            >{{getGroupName($safeNavigationMigration(selectedWidget.settings!.filters['groupId'])) || selectedWidget.settings!.filters['groupId']}}</span
          >
          <button
            mat-icon-button
            class="pill-remove"
            (click)="applyFilterAndLoad(selectedWidget, 'groupId', '')"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        } @if (selectedWidget.type === 'cateringSummary' &&
        selectedWidget.settings!.filters['days'] &&
        selectedWidget.settings!.filters['days'] != 14) {
        <div class="active-pill">
          <mat-icon>date_range</mat-icon>
          <span
            >{{selectedWidget.settings!.filters['days']}}
            {{selectedWidget.settings!.filters['days'] == 1 ? 'dag' : 'dage'}}</span
          >
          <button
            mat-icon-button
            class="pill-remove"
            (click)="applyFilterAndLoad(selectedWidget, 'days', 14)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        } @if (selectedWidget.type === 'cateringSummary' &&
        selectedWidget.settings!.filters['catering_group']) {
        <div class="active-pill">
          <mat-icon>groups</mat-icon>
          <span
            >{{getCateringGroupName($safeNavigationMigration(selectedWidget.settings!.filters['catering_group']))}}</span
          >
          <button
            mat-icon-button
            class="pill-remove"
            (click)="applyFilterAndLoad(selectedWidget, 'catering_group', null)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        } @if ((selectedWidget.settings!.filters['status'] ?? '') !== '' &&
        (selectedWidget.settings!.filters['status'] ?? '') !== 'all') {
        <div class="active-pill status-pill">
          <mat-icon
            >{{selectedWidget.settings!.filters['status'] === 'valid' ? 'check_circle' : selectedWidget.settings!.filters['status'] === 'attention' ? 'warning' : selectedWidget.settings!.filters['status'] === 'no_data' ? 'info' : 'error'}}</mat-icon
          >
          <span
            >{{selectedWidget.settings!.filters['status'] === 'valid' ? 'Gyldig' : selectedWidget.settings!.filters['status'] === 'attention' ? 'Opmærksomhed' : selectedWidget.settings!.filters['status'] === 'no_data' ? 'Ingen data' : 'Ingen sti'}}</span
          >
          <button
            mat-icon-button
            class="pill-remove"
            (click)="applyFilterAndLoad(selectedWidget, 'status', '')"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        } @if (selectedWidget.settings!.filters['sortBy']) {
        <div class="active-pill sort-pill">
          <mat-icon>sort</mat-icon>
          <span
            >{{selectedWidget.settings!.filters['sortBy'] === 'name' ? 'Navn' : selectedWidget.settings!.filters['sortBy'] === 'station' ? 'Station' : selectedWidget.settings!.filters['sortBy'] === 'path' ? 'Uddannelsesvej' : selectedWidget.settings!.filters['sortBy'] === 'registeredPercentage' ? 'Registreret' : selectedWidget.settings!.filters['sortBy'] === 'percentComplete' ? 'Fremgang' : selectedWidget.settings!.filters['sortBy'] === 'averageProgress' ? 'Gns. fremgang' : selectedWidget.settings!.filters['sortBy'] === 'completionRate' ? 'Fuldførelse' : selectedWidget.settings!.filters['sortBy'] === 'userCount' ? 'Antal brugere' : selectedWidget.settings!.filters['sortBy']

            }}&nbsp;<mat-icon
              class="sort-dir-icon"
              >{{selectedWidget.settings!.filters['sortDir'] === 'desc' ? 'arrow_downward' : 'arrow_upward'}}</mat-icon
            ></span
          >
        </div>
        }
      </div>
    </div>
    }
    <!-- Scrollable Filter Body -->
    <div class="filter-panel-body">
      <!-- ── Catering Period Filter ── -->
      @if (selectedWidget.type === 'eventsCalendar') {
      <app-dashboard-events-calendar-filter-panel
        [filters]="selectedWidget.settings!.filters"
        (filtersChange)="onEventsCalendarFilterPanelChange($event)"
      />
      }
      @if (selectedWidget.type === 'cateringSummary') {
      <div class="filter-section">
        <div class="filter-section-header">
          <mat-icon>date_range</mat-icon>
          <span>Periode</span>
        </div>
        <div class="filter-chip-row filter-chip-row--wrap">
          <div
            class="fchip"
            [class.active]="selectedWidget.settings!.filters['days'] == 1"
            (click)="applyFilterAndLoad(selectedWidget, 'days', 1)"
          >
            <mat-icon>today</mat-icon><span>1 dag</span>
          </div>
          <div
            class="fchip"
            [class.active]="selectedWidget.settings!.filters['days'] == 7"
            (click)="applyFilterAndLoad(selectedWidget, 'days', 7)"
          >
            <mat-icon>view_week</mat-icon><span>1 uge</span>
          </div>
          <div
            class="fchip"
            [class.active]="!selectedWidget.settings!.filters['days'] || selectedWidget.settings!.filters['days'] == 14"
            (click)="applyFilterAndLoad(selectedWidget, 'days', 14)"
          >
            <mat-icon>date_range</mat-icon><span>14 dage</span>
          </div>
          <div
            class="fchip"
            [class.active]="selectedWidget.settings!.filters['days'] == 30"
            (click)="applyFilterAndLoad(selectedWidget, 'days', 30)"
          >
            <mat-icon>calendar_month</mat-icon><span>1 måned</span>
          </div>
        </div>
      </div>
      } @if (selectedWidget.type === 'cateringSummary') {
      <div class="filter-section">
        <div class="filter-section-header">
          <mat-icon>groups</mat-icon>
          <span>Forplejningsgruppe</span>
        </div>
        <div class="filter-chip-row filter-chip-row--wrap">
          <div
            class="fchip"
            [class.active]="!selectedWidget.settings!.filters['catering_group']"
            (click)="applyFilterAndLoad(selectedWidget, 'catering_group', null)"
          >
            <mat-icon>filter_alt_off</mat-icon><span>Alle</span>
          </div>
          @for (group of cateringGroupFilterOptions; track group.value) {
          <div
            class="fchip"
            [class.active]="selectedWidget.settings!.filters['catering_group'] == group.value"
            (click)="
              applyFilterAndLoad(selectedWidget, 'catering_group', group.value)
            "
          >
            <mat-icon>group</mat-icon><span>{{ group.label }}</span>
          </div>
          }
        </div>
      </div>
      }
      <!-- ── Simple Number Metric Selection ── -->
      @if (selectedWidget.type === 'simpleNumber') {
      <div class="filter-section">
        <div class="filter-section-header">
          <mat-icon>analytics</mat-icon>
          <span>Vælg Metrik</span>
        </div>
        <div class="filter-chip-grid">
          <div
            class="fchip"
            [class.active]="selectedWidget.dataSource === 'simple_number'"
            (click)="
              applyFilterAndLoad(selectedWidget, 'dataSource', 'simple_number')
            "
          >
            <mat-icon>people</mat-icon><span>Total Brugere</span>
          </div>
          <div
            class="fchip"
            [class.active]="selectedWidget.dataSource === 'user_count'"
            (click)="
              applyFilterAndLoad(selectedWidget, 'dataSource', 'user_count')
            "
          >
            <mat-icon>people_outline</mat-icon><span>Aktive Brugere</span>
          </div>
          <div
            class="fchip"
            [class.active]="selectedWidget.dataSource === 'completion_rate'"
            (click)="
              applyFilterAndLoad(
                selectedWidget,
                'dataSource',
                'completion_rate'
              )
            "
          >
            <mat-icon>trending_up</mat-icon><span>Gns. Fremgang</span>
          </div>
          <div
            class="fchip"
            [class.active]="selectedWidget.dataSource === 'completed_users'"
            (click)="
              applyFilterAndLoad(
                selectedWidget,
                'dataSource',
                'completed_users'
              )
            "
          >
            <mat-icon>check_circle</mat-icon><span>Færdige Brugere</span>
          </div>
          <div
            class="fchip"
            [class.active]="selectedWidget.dataSource === 'users_with_warnings'"
            (click)="
              applyFilterAndLoad(
                selectedWidget,
                'dataSource',
                'users_with_warnings'
              )
            "
          >
            <mat-icon>warning</mat-icon><span>Med Advarsler</span>
          </div>
          <div
            class="fchip"
            [class.active]="
              selectedWidget.dataSource === 'registered_to_progress_ratio'
            "
            (click)="
              applyFilterAndLoad(
                selectedWidget,
                'dataSource',
                'registered_to_progress_ratio'
              )
            "
          >
            <mat-icon>analytics</mat-icon><span>Reg./Fremgang Ratio</span>
          </div>
        </div>
      </div>
      }
      <!-- ── Location Filter ── -->
      @if (selectedWidget.type === 'userProgress' || selectedWidget.type ===
      'userProgressStats' || selectedWidget.type === 'simpleNumber') {
      <div class="filter-section">
        <div class="filter-section-header">
          <mat-icon>location_on</mat-icon>
          <span>Lokation</span>
          @if (isLocationsLoading(selectedWidget)) {
          <span class="loading-badge">Indlæser...</span>
          }
        </div>
        <div class="filter-chip-list">
          <!-- All locations chip -->
          <div
            class="fchip fchip--wide"
            [class.active]="!hasStationFilters(selectedWidget.settings!.filters)"
            (click)="clearStationFilters(selectedWidget)"
          >
            <mat-icon>public</mat-icon><span>Alle lokationer</span>
          </div>
          <!-- Top inline locations (first 8 from cache) -->
          @for (loc of getLocationsForWidget(selectedWidget).slice(0, 8); track
          loc) {
          <div
            class="fchip fchip--wide"
            [class.active]="isStationChipActive(selectedWidget.settings!.filters, loc)"
            (click)="toggleStationFilter(selectedWidget, loc)"
          >
            <mat-icon>location_on</mat-icon><span>{{ loc }}</span>
          </div>
          }
          <!-- More locations button -->
          @if (getLocationsForWidget(selectedWidget).length > 8 ||
          isLocationsLoading(selectedWidget)) {
          <button
            mat-stroked-button
            class="see-all-btn"
            (click)="openLocationSelectionDialog(selectedWidget)"
          >
            <mat-icon>format_list_bulleted</mat-icon>
            <span>{{
              isLocationsLoading(selectedWidget)
                ? "Vis alle lokationer..."
                : "Vis alle (" +
                  getLocationsForWidget(selectedWidget).length +
                  ")"
            }}</span>
          </button>
          } @if (getLocationsForWidget(selectedWidget).length <= 8 &&
          getLocationsForWidget(selectedWidget).length > 0) {
          <button
            mat-stroked-button
            class="see-all-btn"
            (click)="openLocationSelectionDialog(selectedWidget)"
          >
            <mat-icon>search</mat-icon>
            <span>Søg i lokationer</span>
          </button>
          } @if (getLocationsForWidget(selectedWidget).length === 0 &&
          !isLocationsLoading(selectedWidget)) {
          <button
            mat-stroked-button
            class="see-all-btn"
            (click)="openLocationSelectionDialog(selectedWidget)"
          >
            <mat-icon>format_list_bulleted</mat-icon>
            <span>Vis alle lokationer</span>
          </button>
          }
        </div>
      </div>
      }
      <!-- ── User Group Filter ── -->
      @if (selectedWidget.type === 'userProgress' || selectedWidget.type ===
      'userProgressStats' || selectedWidget.type === 'locationProgress' ||
      selectedWidget.type === 'simpleNumber') {
      <div class="filter-section">
        <div class="filter-section-header">
          <mat-icon>groups</mat-icon>
          <span>Brugergruppe</span>
        </div>
        <div class="filter-chip-list">
          <div
            class="fchip fchip--wide"
            [class.active]="!selectedWidget.settings!.filters['groupId'] || selectedWidget.settings!.filters['groupId'] === '' || selectedWidget.settings!.filters['groupId'] === 'all'"
            (click)="applyFilterAndLoad(selectedWidget, 'groupId', '')"
          >
            <mat-icon>public</mat-icon><span>Alle grupper</span>
          </div>
          @if ((selectedWidget.settings!.filters['groupId'] ?? '') !== '' &&
          (selectedWidget.settings!.filters['groupId'] ?? '') !== 'all') {
          <div class="fchip fchip--wide fchip--selected" [class.active]="true">
            <mat-icon>group</mat-icon>
            <span
              >{{getGroupName($safeNavigationMigration(selectedWidget.settings!.filters['groupId'])) || selectedWidget.settings!.filters['groupId']}}</span
            >
          </div>
          }
          <button
            mat-stroked-button
            class="see-all-btn"
            (click)="openGroupSelectionDialog(selectedWidget)"
          >
            <mat-icon>search</mat-icon>
            <span
              >{{(selectedWidget.settings!.filters['groupId'] ?? '') !== '' && (selectedWidget.settings!.filters['groupId'] ?? '') !== 'all' ? 'Skift brugergruppe...' : 'Vælg brugergruppe...'}}</span
            >
          </button>
        </div>
      </div>
      }
      <!-- ── Education Filter ── -->
      @if (selectedWidget.type === 'userProgress' || selectedWidget.type ===
      'userProgressStats' || selectedWidget.type === 'locationProgress' ||
      selectedWidget.type === 'simpleNumber') {
      <div class="filter-section">
        <div class="filter-section-header">
          <mat-icon>school</mat-icon>
          <span>Uddannelsesveje</span>
        </div>
        <div class="filter-chip-list">
          <div
            class="fchip fchip--wide"
            [class.active]="!selectedWidget.settings!.filters['educationalPathId'] || selectedWidget.settings!.filters['educationalPathId'] === '' || selectedWidget.settings!.filters['educationalPathId'] === 'all'"
            (click)="
              applyFilterAndLoad(selectedWidget, 'educationalPathId', '')
            "
          >
            <mat-icon>public</mat-icon><span>Alle uddannelsesveje</span>
          </div>
          @if ((selectedWidget.settings!.filters['educationalPathId'] ?? '')
          !== '' && (selectedWidget.settings!.filters['educationalPathId'] ??
          '') !== 'all') {
          <div class="fchip fchip--wide fchip--selected" [class.active]="true">
            <mat-icon>school</mat-icon>
            <span
              >{{getEducationName($safeNavigationMigration(selectedWidget.settings!.filters['educationalPathId'])) || selectedWidget.settings!.filters['educationalPathId']}}</span
            >
          </div>
          }
          <button
            mat-stroked-button
            class="see-all-btn"
            (click)="openEducationSelectionDialog(selectedWidget)"
          >
            <mat-icon>search</mat-icon>
            <span
              >{{(selectedWidget.settings!.filters['educationalPathId'] ?? '') !== '' && (selectedWidget.settings!.filters['educationalPathId'] ?? '') !== 'all' ? 'Skift uddannelsesvej...' : 'Vælg uddannelsesvej...'}}</span
            >
          </button>
        </div>
      </div>
      }
      <!-- ── Status Filter ── -->
      @if (selectedWidget.type === 'userProgress' || selectedWidget.type ===
      'userProgressStats' || selectedWidget.type === 'locationProgress') {
      <div class="filter-section">
        <div class="filter-section-header">
          <mat-icon>flag</mat-icon>
          <span>Status</span>
        </div>
        <div class="filter-chip-row filter-chip-row--wrap">
          <div
            class="fchip fchip--status"
            [class.active]="!selectedWidget.settings!.filters['status'] || selectedWidget.settings!.filters['status'] === '' || selectedWidget.settings!.filters['status'] === 'all'"
            (click)="applyFilterAndLoad(selectedWidget, 'status', '')"
          >
            <mat-icon>public</mat-icon><span>Alle</span>
          </div>
          <div
            class="fchip fchip--status fchip--ok"
            [class.active]="selectedWidget.settings!.filters['status'] === 'valid'"
            (click)="applyFilterAndLoad(selectedWidget, 'status', 'valid')"
          >
            <mat-icon>check_circle</mat-icon><span>Gyldig</span>
          </div>
          <div
            class="fchip fchip--status fchip--warning"
            [class.active]="selectedWidget.settings!.filters['status'] === 'attention'"
            (click)="applyFilterAndLoad(selectedWidget, 'status', 'attention')"
          >
            <mat-icon>warning</mat-icon><span>Opmærksomhed</span>
          </div>
          <div
            class="fchip fchip--status fchip--no-data"
            [class.active]="selectedWidget.settings!.filters['status'] === 'no_data'"
            (click)="applyFilterAndLoad(selectedWidget, 'status', 'no_data')"
          >
            <mat-icon>info</mat-icon><span>Ingen data</span>
          </div>
          <div
            class="fchip fchip--status fchip--no-paths"
            [class.active]="selectedWidget.settings!.filters['status'] === 'no_paths'"
            (click)="applyFilterAndLoad(selectedWidget, 'status', 'no_paths')"
          >
            <mat-icon>error</mat-icon><span>Ingen sti</span>
          </div>
        </div>
      </div>
      }
      <!-- ── Sort: User Progress ── -->
      @if (selectedWidget.type === 'userProgress' || selectedWidget.type ===
      'userProgressStats') {
      <div class="filter-section">
        <div class="filter-section-header">
          <mat-icon>swap_vert</mat-icon>
          <span>Sortér efter</span>
        </div>
        <div class="sort-chip-list">
          <div
            class="sort-chip"
            [class.active]="selectedWidget.settings!.filters['sortBy'] === 'name'"
            (click)="sortUserProgressData(selectedWidget, 'name')"
          >
            <mat-icon>sort_by_alpha</mat-icon>
            <span>Navn</span>
            @if (selectedWidget.settings!.filters['sortBy'] === 'name') {
            <mat-icon class="sort-dir">
              {{selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
            </mat-icon>
            }
          </div>
          <div
            class="sort-chip"
            [class.active]="selectedWidget.settings!.filters['sortBy'] === 'station'"
            (click)="sortUserProgressData(selectedWidget, 'station')"
          >
            <mat-icon>location_on</mat-icon>
            <span>Station</span>
            @if (selectedWidget.settings!.filters['sortBy'] === 'station') {
            <mat-icon class="sort-dir">
              {{selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
            </mat-icon>
            }
          </div>
          <div
            class="sort-chip"
            [class.active]="selectedWidget.settings!.filters['sortBy'] === 'path'"
            (click)="sortUserProgressData(selectedWidget, 'path')"
          >
            <mat-icon>school</mat-icon>
            <span>Uddannelse</span>
            @if (selectedWidget.settings!.filters['sortBy'] === 'path') {
            <mat-icon class="sort-dir">
              {{selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
            </mat-icon>
            }
          </div>
          <div
            class="sort-chip"
            [class.active]="selectedWidget.settings!.filters['sortBy'] === 'registeredPercentage'"
            (click)="
              sortUserProgressData(selectedWidget, 'registeredPercentage')
            "
          >
            <mat-icon>assignment</mat-icon>
            <span>Registreret</span>
            @if (selectedWidget.settings!.filters['sortBy'] ===
            'registeredPercentage') {
            <mat-icon class="sort-dir">
              {{selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
            </mat-icon>
            }
          </div>
          <div
            class="sort-chip"
            [class.active]="selectedWidget.settings!.filters['sortBy'] === 'percentComplete'"
            (click)="sortUserProgressData(selectedWidget, 'percentComplete')"
          >
            <mat-icon>trending_up</mat-icon>
            <span>Fremgang</span>
            @if (selectedWidget.settings!.filters['sortBy'] ===
            'percentComplete') {
            <mat-icon class="sort-dir">
              {{selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
            </mat-icon>
            }
          </div>
          <div
            class="sort-chip"
            [class.active]="selectedWidget.settings!.filters['sortBy'] === 'status'"
            (click)="sortUserProgressData(selectedWidget, 'status')"
          >
            <mat-icon>info</mat-icon>
            <span>Status</span>
            @if (selectedWidget.settings!.filters['sortBy'] === 'status') {
            <mat-icon class="sort-dir">
              {{selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
            </mat-icon>
            }
          </div>
        </div>
      </div>
      }
      <!-- ── Sort: Location Progress ── -->
      @if (selectedWidget.type === 'locationProgress') {
      <div class="filter-section">
        <div class="filter-section-header">
          <mat-icon>swap_vert</mat-icon>
          <span>Sortér efter</span>
        </div>
        <div class="sort-chip-list">
          <div
            class="sort-chip"
            [class.active]="selectedWidget.settings!.filters['sortBy'] === 'name'"
            (click)="sortLocationProgressData(selectedWidget, 'name')"
          >
            <mat-icon>sort_by_alpha</mat-icon>
            <span>Navn</span>
            @if (selectedWidget.settings!.filters['sortBy'] === 'name') {
            <mat-icon class="sort-dir">
              {{selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
            </mat-icon>
            }
          </div>
          <div
            class="sort-chip"
            [class.active]="selectedWidget.settings!.filters['sortBy'] === 'registeredPercentage'"
            (click)="
              sortLocationProgressData(selectedWidget, 'registeredPercentage')
            "
          >
            <mat-icon>assignment</mat-icon>
            <span>Registreret</span>
            @if (selectedWidget.settings!.filters['sortBy'] ===
            'registeredPercentage') {
            <mat-icon class="sort-dir">
              {{selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
            </mat-icon>
            }
          </div>
          <div
            class="sort-chip"
            [class.active]="selectedWidget.settings!.filters['sortBy'] === 'averageProgress'"
            (click)="
              sortLocationProgressData(selectedWidget, 'averageProgress')
            "
          >
            <mat-icon>trending_up</mat-icon>
            <span>Gns. fremgang</span>
            @if (selectedWidget.settings!.filters['sortBy'] ===
            'averageProgress') {
            <mat-icon class="sort-dir">
              {{selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
            </mat-icon>
            }
          </div>
          <div
            class="sort-chip"
            [class.active]="selectedWidget.settings!.filters['sortBy'] === 'completionRate'"
            (click)="sortLocationProgressData(selectedWidget, 'completionRate')"
          >
            <mat-icon>check_circle</mat-icon>
            <span>Fuldførelse</span>
            @if (selectedWidget.settings!.filters['sortBy'] ===
            'completionRate') {
            <mat-icon class="sort-dir">
              {{selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
            </mat-icon>
            }
          </div>
          <div
            class="sort-chip"
            [class.active]="selectedWidget.settings!.filters['sortBy'] === 'userCount'"
            (click)="sortLocationProgressData(selectedWidget, 'userCount')"
          >
            <mat-icon>people</mat-icon>
            <span>Antal brugere</span>
            @if (selectedWidget.settings!.filters['sortBy'] === 'userCount') {
            <mat-icon class="sort-dir">
              {{selectedWidget.settings!.filters['sortDir'] === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
            </mat-icon>
            }
          </div>
        </div>
      </div>
      }
      <!-- ── Generic filter for other widget types ── -->
      @if (selectedWidget.type !== 'userProgress' && selectedWidget.type !==
      'userProgressStats' && selectedWidget.type !== 'locationProgress' &&
      selectedWidget.type !== 'simpleNumber') {
      <div class="filter-section">
        <div class="filter-section-header">
          <mat-icon>swap_vert</mat-icon>
          <span>Sortér</span>
        </div>
        <div class="form-group">
          <label for="sort-by-gen">Sortér efter</label>
          <select
            id="sort-by-gen"
            [(ngModel)]="selectedWidget.settings!.filters['sortBy']"
          >
            <option value="name">Navn</option>
            <option value="station">Station</option>
            <option value="path">Uddannelsesvej</option>
            <option value="percentComplete">Fremgang</option>
          </select>
        </div>
        <div class="form-group">
          <label for="sort-dir-gen">Rækkefølge</label>
          <select
            id="sort-dir-gen"
            [(ngModel)]="selectedWidget.settings!.filters['sortDir']"
          >
            <option value="asc">Stigende (A–Z, 0–100%)</option>
            <option value="desc">Faldende (Z–A, 100–0%)</option>
          </select>
        </div>
      </div>
      }
    </div>
    <!-- /filter-panel-body -->
    <!-- Panel Footer -->
    <div class="filter-panel-footer">
      <button mat-stroked-button (click)="closeFilterDialog()">Luk</button>
      <button
        mat-raised-button
        color="primary"
        (click)="applyFilterAndCloseDialog()"
      >
        Anvend &amp; luk
      </button>
    </div>
  </div>
  }
</ng-template>

<!-- Layout Selector Dialog -->
@if (isLayoutSelectorOpen) {
<div class="dialog-overlay" (click)="isLayoutSelectorOpen = false">
  <div class="dialog-content layout-dialog" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h2>Vælg dashboard layout</h2>
      <button mat-icon-button (click)="isLayoutSelectorOpen = false">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="dialog-body">
      <div class="layout-grid">
        <!-- Layout templates -->
        @if (availableLayouts.length > 0) { @for (layout of availableLayouts;
        track layout.id) {
        <div class="layout-card">
          <div class="layout-preview">
            <!-- Layout preview based on layout type -->
            <div class="preview-grid" [attr.data-layout-id]="layout.id">
              @switch (layout.id) {
              <!-- Default layout preview -->
              @case ('default') {
              <div
                class="preview-widget"
                style="grid-column: 1/7; grid-row: 1/5"
              ></div>
              <div
                class="preview-widget"
                style="grid-column: 7/13; grid-row: 1/5"
              ></div>
              }
              <!-- Single column layout preview -->
              @case ('single-column') {
              <div
                class="preview-widget"
                style="grid-column: 1/13; grid-row: 1/3"
              ></div>
              <div
                class="preview-widget"
                style="grid-column: 1/13; grid-row: 3/5"
              ></div>
              <div
                class="preview-widget"
                style="grid-column: 1/13; grid-row: 5/7"
              ></div>
              }
              <!-- Dashboard layout preview -->
              @case ('dashboard') {
              <div
                class="preview-widget"
                style="grid-column: 1/5; grid-row: 1/3"
              ></div>
              <div
                class="preview-widget"
                style="grid-column: 5/9; grid-row: 1/3"
              ></div>
              <div
                class="preview-widget"
                style="grid-column: 9/13; grid-row: 1/3"
              ></div>
              <div
                class="preview-widget"
                style="grid-column: 1/7; grid-row: 3/7"
              ></div>
              <div
                class="preview-widget"
                style="grid-column: 7/13; grid-row: 3/7"
              ></div>
              }
              <!-- Fall back to generic preview for custom layouts -->
              @default { @for (widget of getLayoutPreviewWidgets(layout); track
              widget.id ?? $index) {
              <div
                class="preview-widget"
                [ngStyle]="{
                  'grid-column':
                    (widget.x || 0) +
                    1 +
                    '/' +
                    ((widget.x || 0) + (widget.cols || 2) + 1),
                  'grid-row':
                    (widget.y || 0) +
                    1 +
                    '/' +
                    ((widget.y || 0) + (widget.rows || 2) + 1)
                }"
              ></div>
              } } }
            </div>
          </div>
          <div class="layout-info">
            <h3>{{ layout.name }}</h3>
            <p>{{ layout.description || "Ingen beskrivelse" }}</p>
            <div class="layout-actions">
              <button
                mat-raised-button
                color="primary"
                (click)="applyLayoutAndClose(layout.id)"
              >
                Brug dette layout
              </button>
            </div>
          </div>
        </div>
        } } @else {
        <div class="no-layouts-message">
          <mat-icon>info</mat-icon>
          <p>
            Ingen layouts tilgængelige. Opret et layout først ved at gemme dit
            nuværende dashboard layout.
          </p>
        </div>
        }
      </div>
    </div>
  </div>
</div>
}
